module.exports = __webpack_public_path__ + "static/specialsPlaceholder-64d427b69a41374defba3ad49f815f21.jpg";